import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import history from 'Util/History';

import { clearEvents, pushEvent } from '../../store/Matomo/Matomo.action';
import { EVENT_TYPES } from './MatomoTagManager.events';
import { eventTransformationMap } from './MatomoTagManager.eventsManager.js';

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMatomoInitialized: state.MatomoReducer.isMatomoInitialized,
    matomo: state.MatomoReducer.matomo,
    title: state.MetaReducer.title,
    pageType: state.MetaReducer.page_type,
    events: state.MatomoReducer.events,
    currencyCode: state.ConfigReducer.currencyData.current_currency_code
});

// dispatch
/** @namespace Bodymod/Matomo/Component/MatomoTagManger/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    clearEvents: (eventsToClear) => dispatch(clearEvents(eventsToClear)),
    pushEvent: (event, data) => {
        dispatch(pushEvent(event, data));
    }
});

/** @namespace Bodymod/Matomo/Component/MatomoTagManger/Container */
export class MatomoTagMangerContainer extends PureComponent {
    static propTypes = {
        events: PropTypes.arrayOf(
            PropTypes.shape({
                event: PropTypes.string,
                category: PropTypes.string
            })
        ).isRequired,
        matomo: PropTypes.shape({
            push: PropTypes.func.isRequired
        }).isRequired,
        currencyCode: PropTypes.string.isRequired,
        clearEvents: PropTypes.func.isRequired,
        pushEvent: PropTypes.func.isRequired,
        urlRewrite: PropTypes.shape({
            url: PropTypes.string,
            type: PropTypes.string,
            notFound: PropTypes.bool
        }).isRequired,
        title: PropTypes.string.isRequired,
        pageType: PropTypes.string.isRequired
    };

    state = {
        location: history.location
    };

    componentDidMount() {
        history.listen((history) => {
            this.onRouteChanged(history);
        });
    }

    componentDidUpdate(prevProps) {
        const { events } = this.props;
        const { title: prevTitle } = prevProps;
        this.pushGeneralEvents(prevTitle);
        this.pushEvents(events);
    }

    pushGeneralEvents(prevTitle) {
        const {
            pushEvent, title, pageType
        } = this.props;

        if (title && title !== prevTitle) {
            pushEvent(EVENT_TYPES.GENERAL, { title, type: pageType });
        }
    }

    pushEvents(events) {
        const { clearEvents } = this.props;
        const _mtm = window._mtm || [];
        if (events.length) {
            clearEvents(events);
            events.forEach(({ event, data }) => {
                const transformedData = this.transformEventData(event, data);
                try {
                    _mtm.push(transformedData);
                } catch (e) {
                    console.error(e, 'MATOMO ERROR');
                }
            });
        }
    }

    transformEventData(eventType, eventData) {
        const { currencyCode } = this.props;
        const transformationFunction = eventTransformationMap[eventType];
        if (transformationFunction) {
            return transformationFunction({ ...eventData, currencyCode });
        }

        return eventData;
    }

    onRouteChanged(history) {
        const { location: { pathname: prevPathname } } = this.state;
        const { pathname } = history;
        if (prevPathname !== pathname) {
            this.setState({ location: history });
        }
    }

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MatomoTagMangerContainer);
